import PopOver from 'chameleon/ui-stack/ui/base/popover';
import cn from 'classnames';
import { Icon } from 'legacy-packages/ft-cb';
import VerticalPerformanceDetails from 'legacy/src/components/assessment/Results/VerticalPerformanceDetails/index';
import { performanceTierStacks } from 'legacy/src/utility/progressHelpers';
import sortBy from 'lodash/sortBy';
import React from 'react';
import uniqid from 'uniqid';

const StudentCountIcon = (props) => {
  const {
    rubricReference,
    score,
    rubricReportData,
    assignmentReport,
    performanceTiers,
    studentUrl,
    students,
    itemId,
  } = props;

  const scoreStudents = Object.entries(rubricReportData).reduce(
    (acc, [studentId, { items }]) => {
      if (items[rubricReference] && items[rubricReference].score === score) {
        acc.push(studentId);
      }
      return acc;
    },
    [],
  );

  const countLabel = (
    <label
      className={cn(
        !scoreStudents.length ? 'empty' : '',
        'scoring-rubric-student-count-label',
      )}
    >
      {scoreStudents.length}
      <Icon name="person" size="1em" />
    </label>
  );

  const stacks = performanceTierStacks(
    scoreStudents.length,
    assignmentReport,
    performanceTiers,
    students,
    itemId,
  )
    .map((stack) => ({
      ...stack,
      students: sortBy(
        stack.students.filter((student) => scoreStudents.includes(student.id)),
        ['lastName', 'firstName'],
      ),
    }))
    .filter((stack) => stack.students.length !== 0)
    .reverse();

  const responseCounterAriaLabel = `Number of students scoring ${score}: ${scoreStudents.length}`;
  const popoverAriaLabel = stacks.reduce(
    (acc, stack) =>
      `${acc}
    ${stack.type} (${stack.label}):
    ${stack.students.reduce(
      (studentNames, student) =>
        `${studentNames} ${student.firstName} ${student.lastName}`,
      '',
    )}`,
    '',
  );
  const ariaDescribedBy = `option-details-${uniqid()}`;

  return (
    <div className="max-w-1/3 scoring-rubric-student-count">
      {scoreStudents.length ? (
        <PopOver
          showCloseButton
          buttonClassName="inline-block"
          accessibility={{
            'aria-label': responseCounterAriaLabel,
            'aria-describedby': ariaDescribedBy,
          }}
          trigger={countLabel}
        >
          <VerticalPerformanceDetails
            ariaId={ariaDescribedBy}
            aria-label={popoverAriaLabel}
            studentUrl={studentUrl}
            stacks={stacks}
          />
        </PopOver>
      ) : (
        countLabel
      )}
    </div>
  );
};

export default StudentCountIcon;
